import React, { FC } from 'react'
import { Modal, Button } from '@vadiun/react-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { Form, Formik, Field } from 'formik';
import { KeyboardDateTimePicker } from 'formik-material-ui-pickers';
import { Moment } from 'moment';
import * as Yup from 'yup';

interface DownloadExcelModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (values: DownloadExcelFormData) => void;
}
interface DownloadExcelFormData {
  dateFrom: Moment | null;
  dateTo: Moment | null;
}
const initialValues: DownloadExcelFormData = {
  dateFrom: null,
  dateTo: null
}

const DownloadExcelSchema = Yup.object().shape({
  dateFrom: Yup.mixed().required('La fecha desde es requerida'),
  dateTo: Yup.mixed().required('La fecha hasta es requerida'),
})

const DownloadExcelModal: FC<DownloadExcelModalProps> = ({ isOpen, onClose, onSubmit }) => {

  const handleSubmit = async (values: DownloadExcelFormData) => {
    try {
      await onSubmit(values);
    } catch (error) {
      console.error('Error al descargar excel:', error);
    }
  }
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      body={<div className="relative">   <div className="text-center mb-6 mt-10">
        <div className="flex items-center justify-center gap-3 mb-2 relative">
          <div
            className="rounded-full flex items-center justify-center"
            style={{
              boxShadow: '-6px 3px 15px rgba(45, 219, 0, 0.4)',
              position: 'absolute',
              top: '-62px',
              right: '260px',
              width: '70px',
              height: '70px'
            }}
          >
            <FontAwesomeIcon
              icon={faFileExcel}
              className="text-white text-5xl"
              style={{
                color: '#21a366'
              }}
            />
          </div>
          <div
            className="w-12 h-12 rounded-full flex items-center justify-center"
            style={{
              boxShadow: '6px -3px 10px rgba(61, 163, 33, 0.4)',
              position: 'absolute',
              top: '-70px',
              right: '220px'
            }}
          >
            <FontAwesomeIcon
              icon={faArrowDown}
              className="text-white text-2xl"
              style={{
                color: '#21a366'
              }}
            />
          </div>
        </div>
        <h2
          className="texonSubmitt-2xl font-bold  mt-6"
          style={{
            color: '#21a366',
            textShadow: '1px 1px 2px rgba(45, 219,0, 0.4)'
          }}
        >
          Descargar Informe
        </h2>
        <p className="text-gray-600 mt-1">
          Ingrese las fechas desde y hasta para descargar el informe
        </p>
      </div>
        <Formik<DownloadExcelFormData>
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
          validationSchema={DownloadExcelSchema}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, dirty }) => (
            <Form onSubmit={handleSubmit}>
              <div className="grid grid-cols-2 gap-x-3">
                <Field
                  component={KeyboardDateTimePicker}
                  label="Desde"
                  name="dateFrom"
                  ampm={false}
                  inputVariant="outlined"
                  margin="dense"
                  format="DD/MM/YYYY HH:mm"
                />
                <Field
                  component={KeyboardDateTimePicker}
                  label="Hasta"
                  name="dateTo"
                  ampm={false}
                  inputVariant="outlined"
                  margin="dense"
                  format="DD/MM/YYYY HH:mm"
                />
              </div>
              <div
                className="flex justify-between gap-2 pt-4"
                style={{
                  marginBottom: '-16px'
                }}
              >
                <Button
                  type="button"
                  variant="light"
                  color="gray"
                  onClick={onClose}
                  disabled={isSubmitting}
                >
                  Cancelar
                </Button>
                <Button type="submit" variant="contained" color="primary" disabled={isSubmitting || !dirty}>
                  Descargar
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>}
    />
  )
}

export default DownloadExcelModal